import React from 'react';
import styled from 'styled-components';
import BrandComponent from '../components/brand';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 90dvh;
  background-color: #f9fafb;
  padding: 1rem;
  box-sizing: border-box;

  @media(max-width:991px){
    justify-content: flex-start;
  }

  & svg{
    width: 150px;
  }
`;

const Box = styled.div`
  max-width: 400px;
  padding: 2rem;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.1);
`;

const Title = styled.h1`
  font-size:36px;
  margin-bottom: 1rem;
  color: #E9531E;
  text-align: center
`;

const Text = styled.p`
  font-weight: 600;
  text-align: center
`;


export default function NotFoundPage() {
  return (
    <Wrapper>
      <BrandComponent />
      <Box>
        <Title>Ups</Title>
        <Text>Lo sentimos, el recurso que buscas no existe.</Text>
      </Box>
    </Wrapper>
  );
}